import {AccountService} from '~local/app/shared/services/AccountService';
import {CurrencyService} from '~local/app/shared/services/CurrencyService';
import {UserService} from '~local/app/shared/services/UserService';
import {ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot} from '@angular/router';
import {zip} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {inject} from '@angular/core';

export const userDataExistsGuard: CanActivateChildFn = ($childRoute: ActivatedRouteSnapshot, $state: RouterStateSnapshot) => {
        const accountService = inject(AccountService);
        const userService = inject(UserService);
        const currencyService = inject(CurrencyService);

        return zip([
            accountService.accounts$.pipe(filter($ => Array.isArray($))),
            currencyService.currencies$.pipe(filter($ => Array.isArray($))),
            userService.userData$.pipe(filter($ => $ !== null)),
        ]).pipe(
            map(() => true),
        );
    }
